import React, { useState } from "react";
import { Link } from "@mui/material";
import { withRouter } from "next/router";
import { WithRouterProps } from "next/dist/client/with-router";
import { SingleSession } from "../../../../../models/Session";
import { Button, Checkbox, InfoMessage, TitleSubtitle, Tooltip } from "../../../../../components";
import { TermsContainer, StyledLink } from "./TermsStep.styles";
import { SingleShow } from "../../../../../models/Show";
import Page from "../../../../../components/Page/Page";
import {
  CTAButtonContainer,
  ButtonContainer,
  ButtonIcon,
  ButtonLabel,
} from "../../BookingManager.styles";
import { useModal, Modals } from "../../../../../contexts/ModalContext";
import { Modal } from "../../../../../components"
import { StyledBlueSpan } from "../Tickets/TicketsStep.styles";
import { formatString } from "../../../../../utils/string-utils";
import { tncTemplate } from "../../../../../utils/constants";

interface TermsStepProps extends WithRouterProps {
  onNextButtonClick: Function;
  onPrevButtonClick: Function;
  show: SingleShow;
  session: SingleSession | undefined;
  submitting: boolean;
  errorMessage?: string;
  bookingInterestError?: boolean;
}

const TermsStep: React.FC<TermsStepProps> = ({
  router,
  onNextButtonClick,
  onPrevButtonClick,
  show,
  session,
  submitting,
  errorMessage = "",
  bookingInterestError = false
}) => {
  const [isSessionAgreed, setIsSessionAgreed] = useState<boolean>(false);
  const [isTTTAgreed, setIsTTTAgreed] = useState<boolean>(false);
  const { openModal, closeModal, modalState } = useModal();

  return (
    <TermsContainer data-cy="termsContainer">
      <TitleSubtitle
        title="Accept Terms & Apply!"
        subTitle="So you can be part of the audience at a live TV recording, please read and accept the following terms and conditions:"
      />
      {session?.termsAndConditionsId !== null && (
        <Checkbox
          data-cy="tc-checkbox-1"
          checked={isSessionAgreed}
          onChange={setIsSessionAgreed}
          label={
            <div>
              I agree to the{" "}
              <StyledLink
                data-cy="session-terms-link"
                target="_blank"
                href={`/api/backend/termsandconditions?id=${session?.termsAndConditionsId}`}
              >
                {formatString(tncTemplate, show?.name)}
              </StyledLink>
            </div>
          }
        />
      )}

      <Checkbox
        data-cy="tc-checkbox-2"
        checked={isTTTAgreed}
        onChange={setIsTTTAgreed}
        label={
          <div>
            I understand that having tickets  <Tooltip tooltipName="showMustGoOn"><StyledBlueSpan> does not guarantee </StyledBlueSpan></Tooltip> me entry to the show
          </div>
        }
      />

      {bookingInterestError && (
        <InfoMessage message={errorMessage} hasBackground variant="error" />
      )}

      <CTAButtonContainer>
        <Button
          size="md"
          variant="tertiary"
          onClick={() => onPrevButtonClick()}
          sx={{ padding: 0 }}
        >
          <ButtonContainer>
            <ButtonIcon icon="ArrowLeft" />
            <ButtonLabel>Back</ButtonLabel>
          </ButtonContainer>
        </Button>
        <Button
          size="md"
          gradientStyle="gradient3"
          onClick={() => openModal(Modals.TermsHighlight, () => {
            closeModal();
            onNextButtonClick()
          })}
          disabled={
            (session?.termsAndConditionsId !== null && !isSessionAgreed) ||
            !isTTTAgreed
          }
          data-cy="submit-interest-button"
          loading={submitting}
        >
          Continue
        </Button>
      </CTAButtonContainer>
      <Modal />
    </TermsContainer>
  );
};

export default withRouter(TermsStep);
